import { METHODS_ACTIONS } from 'constants/Actions/Methods';

// Estado inicial del reducer
const aInitialState = {
    aMethods: [],

    oMethod: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los métodos de extracción del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const MethodReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case METHODS_ACTIONS.GET:
            return { ...aState, aMethods: oAction.data };
        case METHODS_ACTIONS.FIND:
            return { ...aState, oMethod: oAction.data };
        case METHODS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case METHODS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case METHODS_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, aMethods: [], oMethod: null };
        default:
            return aState;
    }
}
